/**
 * Note:
 * All services have been relocated to the settings application.
 * This notice/file will be removed once the impact analysis is completed.
 */
import https from "../repositories/https";
const resource = "/mailbox";

export default {
  fetchList(payload, config) {
    return https.post(`${resource}es.json`, payload, config);
  },
  create(payload, config) {
    return https.post(`${resource}.json`, payload, config);
  },
  getSingle(Id, config) {
    return https.get(`${resource}/${Id}`, config);
  },
  delete(Id, config) {
    return https.delete(`${resource}/${Id}`, config);
  },
  update(id, payload, config) {
    return https.put(`${resource}/${id}`, payload, config);
  },
  verify(Id, config) {
    return https.put(`${resource}/${Id}/verify`, config);
  },
  forwardEmail(payload, config) {
    return https.post(`${resource}/forward_email`, payload, config);
  },
};
